import { render } from "./CompleteTheSet.vue?vue&type=template&id=49a5c50a&scoped=true"
import script from "./CompleteTheSet.vue?vue&type=script&lang=js"
export * from "./CompleteTheSet.vue?vue&type=script&lang=js"

import "./CompleteTheSet.vue?vue&type=style&index=0&id=49a5c50a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a5c50a"]])

export default __exports__